module.exports = __webpack_public_path__ + "img/chevron-bar-contract.85963c72.svg";